import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=9bc33a04"
import script from "./ReportHeader.vue?vue&type=script&lang=js"
export * from "./ReportHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports